module.exports = __webpack_public_path__ + "img/fi-rr-arrow-small-down.2c920f09.svg";